/* Medición de la landing: mapas de calor (Microsoft Clarity), ratios de
   embudo y eventos propios, todo detrás del consentimiento del visitante.

   Cómo funciona
   - Nada se carga hasta que la API de privacidad de Shopify confirma el
     consentimiento de analítica (ajuste «Exigir consentimiento», activo por
     defecto). Mientras tanto los eventos se acumulan en una cola.
   - Clarity necesita acceso al DOM para dibujar mapas de calor, así que va en
     el tema y no en un píxel personalizado (los píxeles corren aislados).
   - Cada evento se envía a Clarity (como etiqueta filtrable), a GA4 si hay
     ID configurado y a window.dataLayer.

   Eventos: landing_view · section_view · scroll_depth · cta_click ·
   outbound_click · waitlist_submit · waitlist_signup · engaged ·
   signup_source_answer (la respuesta a «¿cómo nos has conocido?» del acuse,
   `T2.45` B: solo `answer`, uno de cinco códigos). */
(function () {
  var config = window.ARU_ANALYTICS || {};
  var queue = [];
  var ready = false;
  var seenSections = {};
  var seenDepth = {};

  window.dataLayer = window.dataLayer || [];

  function send(name, params) {
    var payload = params || {};
    window.dataLayer.push(Object.assign({ event: name }, payload));
    if (!ready) { queue.push([name, payload]); return; }
    dispatch(name, payload);
  }

  function dispatch(name, payload) {
    if (window.clarity) {
      try {
        window.clarity('event', name);
        Object.keys(payload).forEach(function (key) {
          window.clarity('set', 'aru_' + key, String(payload[key]));
        });
      } catch (error) { /* la medición nunca rompe la página */ }
    }
    if (window.gtag) {
      try { window.gtag('event', name, payload); } catch (error) { /* idem */ }
    }
  }

  function flush() {
    ready = true;
    queue.splice(0).forEach(function (entry) { dispatch(entry[0], entry[1]); });
  }

  /* ---------- carga de proveedores ---------- */
  function loadClarity(id) {
    if (!id || window.clarity) return;
    (function (c, l, a, r, i) {
      c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments); };
      var t = l.createElement(r); t.async = 1; t.src = 'https://www.clarity.ms/tag/' + i;
      var y = l.getElementsByTagName(r)[0]; y.parentNode.insertBefore(t, y);
    })(window, document, 'clarity', 'script', id);
  }

  function loadGa4(id) {
    if (!id || window.gtag) return;
    var script = document.createElement('script');
    script.async = true;
    script.src = 'https://www.googletagmanager.com/gtag/js?id=' + id;
    document.head.appendChild(script);
    window.gtag = function () { window.dataLayer.push(arguments); };
    window.gtag('js', new Date());
    window.gtag('config', id, { anonymize_ip: true });
  }

  function start() {
    loadClarity(config.clarityId);
    loadGa4(config.ga4Id);
    flush();
  }

  function allowed() {
    try {
      var api = window.Shopify && window.Shopify.customerPrivacy;
      return !!(api && api.analyticsProcessingAllowed && api.analyticsProcessingAllowed());
    } catch (error) { return false; }
  }

  function waitForConsent() {
    if (!config.requireConsent) { start(); return; }
    var started = false;
    function attempt() {
      if (started || !allowed()) return;
      started = true;
      start();
    }
    document.addEventListener('visitorConsentCollected', attempt);
    if (window.Shopify && window.Shopify.loadFeatures) {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () { attempt(); });
    } else {
      attempt();
    }
  }

  /* ---------- eventos de la landing ---------- */
  function trackSections() {
    var sections = document.querySelectorAll('[data-aru-section]');
    if (!sections.length || !('IntersectionObserver' in window)) return;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var id = entry.target.getAttribute('data-aru-section');
        if (seenSections[id]) return;
        seenSections[id] = true;
        send('section_view', { section: id, order: entry.target.getAttribute('data-aru-order') || '' });
        if (window.clarity) { try { window.clarity('set', 'aru_max_section', id); } catch (error) { /* noop */ } }
      });
    }, { threshold: 0.5 });
    Array.prototype.forEach.call(sections, function (section) { observer.observe(section); });
  }

  function trackDepth() {
    var marks = [25, 50, 75, 100];
    function onScroll() {
      var height = document.documentElement.scrollHeight - window.innerHeight;
      if (height <= 0) return;
      var percent = Math.round((window.scrollY / height) * 100);
      marks.forEach(function (mark) {
        if (percent >= mark && !seenDepth[mark]) {
          seenDepth[mark] = true;
          send('scroll_depth', { percent: mark });
        }
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  function trackClicks() {
    document.addEventListener('click', function (event) {
      var cta = event.target.closest('[data-aru-cta]');
      if (cta) {
        var host = cta.closest('[data-aru-section]');
        send('cta_click', {
          label: cta.getAttribute('data-aru-cta'),
          section: host ? host.getAttribute('data-aru-section') : ''
        });
        return;
      }
      var out = event.target.closest('[data-aru-outbound]');
      if (out) send('outbound_click', { label: out.getAttribute('data-aru-outbound') });
    });
  }

  function trackForm() {
    var form = document.querySelector('[data-aru-newsletter]');
    if (form) {
      form.addEventListener('submit', function () {
        var interests = form.querySelectorAll('[data-aru-interest]:checked').length;
        send('waitlist_submit', { interests: interests });
      });
    }
    var confirmed = config.signupCompleted
      || !!document.querySelector('[data-aru-signup]')
      || /customer_posted=true/.test(window.location.search);
    if (confirmed) send('waitlist_signup', { source: 'landing' });
  }

  /* La pregunta «¿cómo nos has conocido?» del acuse (`T2.45` B,
     `assets/aru-origen.js`) avisa con el evento del navegador
     `aru:respuesta-origen`, y aquí sale como `signup_source_answer` por
     `send()`, que la guarda en la cola hasta el consentimiento. Solo los cinco
     códigos de la pregunta y una sola vez por carga; nada de la persona. */
  function trackSourceAnswer() {
    var answers = ['instagram', 'tiktok', 'boca_a_boca', 'paso_por_delante', 'otro'];
    var answered = false;
    document.addEventListener('aru:respuesta-origen', function (event) {
      var answer = event && event.detail && event.detail.answer;
      if (answered || answers.indexOf(answer) === -1) return;
      answered = true;
      send('signup_source_answer', { answer: answer });
    });
  }

  function trackEngagement() {
    var timer = window.setTimeout(function () { send('engaged', { seconds: 15 }); }, 15000);
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') window.clearTimeout(timer);
    });
  }

  send('landing_view', { template: config.template || '' });
  trackSections();
  trackDepth();
  trackClicks();
  trackForm();
  trackSourceAnswer();
  trackEngagement();
  waitForConsent();
})();
